export function asFiniteNumber(value: unknown, fallback = 0) {
	const numeric = Number(value);
	return Number.isFinite(numeric) ? numeric : fallback;
}

export function amountToCents(value: unknown) {
	const amount = asFiniteNumber(value, 0);
	const roundedAmount = Math.round(amount * 100) / 100;
	return Math.round(roundedAmount * 100);
}
